module.exports = __webpack_public_path__ + "media/images/pages/primary-toolkit/phil-df072237399c31fbcce364f1af46d17a.png";